import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { SelectComponent } from '../../../../../shared/select';
import { LesseeFormComponent } from '../lessee-form';
import { Lessee, LesseeProviders } from '../../../../../_models';

@Component({
    selector: 'app-lessee-new',
    templateUrl: '../lessee-form/lessee-form.component.html',
    styleUrls: ['../lessee-form/lessee-form.component.scss'],
    providers: [LesseeProviders]
})

export class LesseeNewComponent extends LesseeFormComponent {
    constructor(private lesseeDataNew: Lessee, private fbNew: FormBuilder,
        private _locationNew: Location, private _routerNew: Router,
    ) {
        super(lesseeDataNew, fbNew, _locationNew, _routerNew);
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid) this.requests$ =
                this.lesseeData.post(formValue);
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/lessees/lessee-new/lessee-new.component.ts